export default "__VITE_ASSET__BNLw0kaw__"